module.exports = __webpack_public_path__ + "img/accordion.be5030ca.webp";